import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomTabs from "components/tabs/customTab";
import InvoiceCard from "./InvoiceCard";
import LeaveRequestsCard from "./LeaveRequestsCard";
import TasksCard from "./TasksCard";
import { Badge } from "antd";
import DueSoonCard from "./DueSoonCard";

const ActionTabs = () => {
  const [activeTab, setActiveTab] = useState("all");
  const location = useLocation();
  const actionRequiredData = useSelector((state) => state.dashboard.clientActionRequiredSummary.data);

  const leaveCount= actionRequiredData.pendingLeaveCount;
  const overdueCount=actionRequiredData.invoiceOverDueCount;
  const dueSoonCount=actionRequiredData.invoiceDueSoonCount;
  const tasksCount=actionRequiredData.taskCount;

  useEffect(() => {
    if (location.hash === "#action-required") {
      setActiveTab("all");
    }
  }, [location.hash]);
  
  const allCount = overdueCount + leaveCount + dueSoonCount + tasksCount;
  const invoicesCount = overdueCount + dueSoonCount; 
  const TabLabel = ({ text, count, color }) => (
    <div className="flex items-center justify-center gap-2">
      <span className="text-sm font-medium">{text}</span>
      <Badge
        count={count}
        size="small"
        style={{
          backgroundColor: color,
          fontSize: "9px",
        }}
      />
    </div>
  );

  const tabOptions = [
    { label: <TabLabel text="All" count={allCount} color="rgb(251 44 54)" />, value: "all" }, 
    { label: <TabLabel text="Leaves" count={leaveCount} color="rgb(251 44 54)" />, value: "leaves" }, 
    { label: <TabLabel text="Invoices" count={invoicesCount} color="rgb(255 105 0)" />, value: "invoices" }, 
    { label: <TabLabel text="Tasks" count={tasksCount} color="rgb(139 92 246)" />, value: "tasks" }, 
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-9"
        activeTab={activeTab}
        onChange={setActiveTab}
      />

      <div className="mt-3 space-y-4">
        {(activeTab === "all" || activeTab === "invoices") && (
          <>
            <InvoiceCard invoiceList={actionRequiredData?.invoiceOverDueList}/>
          </>
        )}
        {(activeTab === "all" || activeTab === "leaves") && <LeaveRequestsCard />}
        {(activeTab === "all" || activeTab === "invoices") && (
            <InvoiceCard 
              type="due_soon" 
              invoiceList={actionRequiredData?.invoiceDueSoonList}
            />
        )}
        {(activeTab === "all" || activeTab === "tasks") && <TasksCard />}
      </div>
    </div>
  );
};

export default ActionTabs;
